import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield, FiPackage, FiLock, FiKey } from 'react-icons/fi';
import { CampoSelect } from './CamposFormulario';
import AsignadorServicios from './AsignadorServicios';
import { ROL_LABELS, DEPTO_LABELS, esStaff } from '../../../../constants/usuarios';

/** Permisos, servicios y seguridad. Solo para administradores. */
const FormularioAjustes = ({
  form, onCampo,
  catalogoServicios, serviciosAsignados, onAlternarServicio, cargandoServicios,
  reseteando, onResetearContrasena,
}) => {
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  return (
    <>
      <h4 className="perfil-form-seccion"><FiShield /> Permisos</h4>

      <div className="perfil-form-grid">
        <CampoSelect id="campo-rol" name="role" label="Rol" value={form.role} onChange={cambiar}>
          {Object.entries(ROL_LABELS).reverse().map(([valor, label]) => (
            <option key={valor} value={valor}>{label}</option>
          ))}
        </CampoSelect>

        {esStaff(form.role) && (
          <CampoSelect
            id="campo-dpto"
            name="dpto_tecnico"
            label="Departamento técnico"
            value={form.dpto_tecnico}
            onChange={cambiar}
          >
            {Object.entries(DEPTO_LABELS).map(([valor, label]) => (
              <option key={valor} value={valor}>{label}</option>
            ))}
          </CampoSelect>
        )}
      </div>

      <CampoSelect
        id="campo-estado"
        name="estado"
        label="Estado de la cuenta"
        hint='Los usuarios "Sin verificar" no tendrán acceso al soporte técnico.'
        value={form.estado}
        onChange={cambiar}
      >
        <option value="verificar">Sin verificar</option>
        <option value="verificado">Verificado</option>
        <option value="suspendido">Suspendido</option>
      </CampoSelect>

      <h4 className="perfil-form-seccion"><FiPackage /> Servicios contratados</h4>

      <div className="perfil-form-campo">
        <label id="label-servicios">Servicios asignados</label>
        <span className="perfil-form-hint">
          Marca los servicios que tenga contratados el cliente. El catálogo se gestiona desde{' '}
          <Link to="/dashboard/gestion-servicios">Gestión → Servicios</Link>.
        </span>

        {cargandoServicios ? (
          <p className="srv-asignador-vacio">Cargando catálogo…</p>
        ) : (
          <AsignadorServicios
            catalogo={catalogoServicios}
            seleccionados={serviciosAsignados}
            onAlternar={onAlternarServicio}
          />
        )}
      </div>

      <h4 className="perfil-form-seccion"><FiLock /> Seguridad</h4>

      <div className="perfil-form-campo">
        <label>Contraseña</label>
        <span className="perfil-form-hint">
          Genera una contraseña temporal para entregar al usuario si la ha olvidado. Se aplica al instante.
        </span>
        <button
          type="button"
          className="perfil-btn-danger-outline"
          onClick={onResetearContrasena}
          disabled={reseteando}
        >
          <FiKey /> {reseteando ? 'Reseteando…' : 'Resetear contraseña'}
        </button>
      </div>
    </>
  );
};

export default FormularioAjustes;
